import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Container,
    Typography,
  } from "@mui/material";

  import { Link, useNavigate } from "react-router-dom";
  import { useSelector } from "../store";

  import React, { useEffect } from "react";
  import plus from "../assets/images/website/plus.png";
  
  function WhatIsPovego() {
    const [expanded, setExpanded] = React.useState(false);
    const navigate = useNavigate()
    const { username } = useSelector((state) => state.auth);

    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
    const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };
    return (
      <React.Fragment>
        <Container maxWidth="xl">
            <Box
              sx={{
                maxWidth: "1400px",
                padding: {xs: '65px 0px 107px' , lg: "140px 0px"},
                margin: "auto",
                textAlign: "center",
              }}
            >
            
              

              <Typography
                sx={{
                  color: "#000",
                  fontWeight: 700,
                  fontFamily: '"Inter", sans-serif',
                  fontSize: { xs: 36, lg: 54 },
                  lineHeight: { xs: '44px', lg: "65px" },
                  maxWidth: '500px',
                  margin: { xs: 'auto', lg: 0 },
                  textAlign: { xs: 'center', lg: 'start' }
                }}
              >
               What is Povego?
              </Typography>
              <Typography
                sx={{
                  color: "#000",
                  fontWeight: 400,
                  fontFamily: '"Inter", sans-serif',
                  fontSize: { xs: 18, lg: 22 },
                  padding: "24px 0px 60px",
                  textAlign: { xs: 'center', lg: 'start' }
                }}
              >
              Povego is a marketplace where you can trade crypto assets.<br/><br/>
              It is Türkiye's blockchain-based investment platform.<br/><br/>
              It was founded in 2023 by an expert team from the technology and finance worlds.<br/><br/>
              The strong experience of FIA (Financial Communication Agency), Türkiye's first Financial Communication Agency, which has been providing financial communication services to Türkiye's leading finance brands for 6 years, became the cornerstone of Povego. Since stepping into the financial world, we have reinforced the financial communication consultancy experience we offer to the leading actors of the capital markets, which has inspired the communication ecosystem, with Povego, which we started to popularize blockchain-based investments in Türkiye. As Povego, we aim to maintain our pioneering role in the investment world of the future steadily.<br/><br/>

              We are starting a new era in the investment world. With our innovative platform, we offer our investors a safer, more transparent, and accessible investment environment.<br/><br/>
              <strong>Reliable and Transparent Crypto Asset Platform</strong><br/><br/>
              When establishing Povego, our primary goal was to move crypto assets to the digital world in a secure, transparent, and speculation-free manner. Povego is the most reliable way to buy and sell the crypto assets you own.<br/><br/>

              <strong>Predictable Investment Environment</strong><br/><br/>
              For us, trust comes before everything else. Based on this priority, we constantly update and develop our platform to prevent speculation and keep security at the highest level. Thus, we create a transparent and fair trading environment in the Povego ecosystem where every investor will feel safe. This reliable and transparent environment provided by Povego supports our investors while offering new opportunities to asset owners.<br/><br/>

              <strong>What Are These Opportunities?</strong><br/><br/>
              Tokenizing real-world assets and moving them to the digital world significantly increases the liquidity of the assets. Selling or investing through traditional methods can often be time-consuming and complex. However, with Povego, these processes become faster and easier. Tokenized assets can be traded 24/7, providing investors with continuous access. Additionally, tokenized assets overcome geographical boundaries to reach a wider audience of investors. This facilitates asset owners' access to international investors and expands the potential investor pool. Consequently, a more dynamic and accessible investment environment is created for both asset owners and investors.<br/><br/>

              <strong>A New Era in the Investment World</strong><br/><br/>
              As Povego, we are launching a new era in the investment world. With our innovative platform, we offer a safer, more transparent, and accessible investment environment to our investors. We aim to meet the needs of both individual and institutional investors. With our principle of transparency, we prioritize open and honest communication at every step; with the importance we attach to security, we use the latest technologies to protect our users' assets. With this vision, we believe that we will achieve greater success not only today but also in the future. We will continue to pioneer revolutionary changes in the investment world and continue to grow by reaching wider audiences.<br/><br/>
              </Typography>
            </Box>
          </Container>
      </React.Fragment>
    );
  }
  
  export default WhatIsPovego;
  
